import { render, staticRenderFns } from "./DashboardEventItem.vue?vue&type=template&id=609f13df&"
import script from "./DashboardEventItem.vue?vue&type=script&lang=js&"
export * from "./DashboardEventItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('609f13df')) {
      api.createRecord('609f13df', component.options)
    } else {
      api.reload('609f13df', component.options)
    }
    module.hot.accept("./DashboardEventItem.vue?vue&type=template&id=609f13df&", function () {
      api.rerender('609f13df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/dashboard/DashboardEventItem.vue"
export default component.exports